import VueLocalForage from 'vue-localforage'

export default (vueInstance) => {
  vueInstance.use(VueLocalForage)
}
